<template>
  <v-app>
    <v-main>
      <bestaetigung v-if="bestaetigungscode" :code="bestaetigungscode"/>
      <anmeldung v-else/>
    </v-main>
  </v-app>
</template>

<script>
import anmeldung from './components/anmeldung';
import bestaetigung from './components/Bestaetigung';

export default {
  name: 'App',
  components: {
    anmeldung,
    bestaetigung,
  },

  data: () => ({
    bestaetigungscode: new URLSearchParams(window.location.search).get('bestaetigen'),
  }),
};
</script>
